import axiosInstance from '@/store/axios'
import { rejectError } from '@/store/helper'

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // eslint-disable-next-line no-unused-vars
    channels ({ commit }, params) {
      return axiosInstance.get('/api/v1/channels', { params })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    getChannelById ({ commit }, params) {
      return axiosInstance.get(`/api/v1/channels/${params.id}`, { params })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    updateChannel ({ dispatch }, channel) {
      return axiosInstance({
        method: 'PATCH',
        url: `/api/v1/channels/${channel.id}`,
        data: channel,
      })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    channelStatuses ({ commit }, params) {
      return axiosInstance.get('/api/v1/channels/statuses', { params })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    channelCurrentPrograms ({ commit }, params) {
      return axiosInstance.get('/api/v1/current-on-channels', { params })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    thirdPartyChannels ({ commit }, params) {
      return axiosInstance.get('/api/v1/third-party-channels', { params })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    createThirdPartyChannel ({ dispatch }, channel) {
      return axiosInstance({
        method: 'POST',
        url: '/api/v1/third-party-channels',
        data: channel,
      })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    updateThirdPartyChannel ({ dispatch }, channel) {
      return axiosInstance({
        method: 'PATCH',
        url: `/api/v1/third-party-channels/${channel.id}`,
        data: channel,
      })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    updateThirdPartyChannelDistributions ({ dispatch }, channel) {
      return axiosInstance({
        method: 'PATCH',
        url: `/api/v1/third-party-channels/${channel.id}/update-distributions`,
        data: channel,
      })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    bulkUpdateThirdPartyChannel ({ commit }, data) {
      return axiosInstance({
        method: 'POST',
        url: '/api/v1/third-party-channels/bulk-update',
        data: data,
      })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    deleteThirdPartyChannel ({ dispatch }, id) {
      return axiosInstance({
        method: 'DELETE',
        url: `/api/v1/third-party-channels/${id}`,
      })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    getChannelReport ({ commit }) {
      return axiosInstance.get('/api/v1/channel-report', { responseType: 'blob' })
        .then((result) => result)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    adItems ({ commit }, params) {
      return axiosInstance.get('/api/v1/ad-items', { params })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    setAdToChannels ({ commit }, data) {
      return axiosInstance({
        method: 'POST',
        url: `/api/v1/ad-items/${data.id}/set-channels`,
        data: data.ids,
      })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    updateAdItem ({ dispatch }, adItem) {
      return axiosInstance({
        method: 'PATCH',
        url: `/api/v1/ad-items/${adItem.id}`,
        data: adItem,
      })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    adItemsUpcomingImpressions ({ commit }, params) {
      return axiosInstance.get('/api/v1/ad-items/upcoming-impressions', { params })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
  },
}
